// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3ZZiw","inputWrap":"CustomTip_inputWrap__1JR27"};